module.exports = __webpack_public_path__ + "static/media/29COICT7.eb2a5e75.jpg";